export default function formatMessageContentSwiperImgText ({
    data: swiperList/* ,
    guide_text,
    mode */
}) {
    return {
        swiperList: swiperList.map(swiperItem => {
            const options = swiperItem.recommends || []
            return {
                name: swiperItem.title,
                desc: swiperItem.description,
                image: swiperItem.img_url,
                data: swiperItem.send,
                options: options.map(item => {
                    return {
                        text: item
                    }
                })
            }
        })
    }
}
